import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as admin from '../../../../admin'
import * as common from '../../../../common'

export const DOC = gql`
  ${admin.users.gql.fragments.shareableUserInfo.DOC}
  ${common.gql.fragments.dateWithUtcOffset.DOC}
  fragment FragmentCheckInResponse on CheckInResponse {
    from {
      ...FragmentShareableUserInfo
    }
    mood
    prompt
    response
    submittedOn {
      ...FragmentDateWithUtcOffset
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentCheckInResponseFragment,
  ents.core.summit.CheckIn.Response
>({
  from: graphql.transformers.OUT.lazyDefault(
    admin.users.gql.fragments.shareableUserInfo.TRANSFORMER,
    () =>
      graphql.transformers.OUT.nonNull(
        admin.users.gql.fragments.shareableUserInfo.TRANSFORMER,
      ).getEntityFrom({}),
  ),
  mood: transformers.PASS_THROUGH,
  prompt: transformers.PASS_THROUGH,
  response: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  submittedOn: graphql.transformers.OUT.validate(
    common.gql.fragments.dateWithUtcOffset.TRANSFORMER,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})
